/**
 * 获取当前路由信息
 */
import {useMatches} from 'react-router-dom'
import {Params} from '@remix-run/router'

// @Override ReturnType<typeof useMatches>
type TMatches = {
  id: string;
  pathname: string;
  params: Params<string>;
  data: unknown;
  handle: {
    title?: string,
  }
}[]

export const useCurrentRoute = () => {
  const matches: TMatches = useMatches();
  return matches[matches.length - 1];
}
